import { DateTime } from 'luxon'

import type { ScheduleDayMap, Session } from './types'

/** Agrupa sessões por data ISO, com as sessões de cada dia em ordem cronológica. */
export const groupByDate = (items: Session[]): ScheduleDayMap => {
  const group: ScheduleDayMap = {}

  items.forEach(item => {
    const date = DateTime.fromISO(item.start_at).toISODate()
    if (!date) return
    group[date] ??= []
    group[date].push(item)
  })

  Object.keys(group).forEach(key => {
    group[key].sort(
      (a, b) =>
        DateTime.fromISO(a.start_at).toMillis() -
        DateTime.fromISO(b.start_at).toMillis()
    )
  })

  return Object.fromEntries(
    Object.keys(group)
      .sort()
      .map(key => [key, group[key]])
  )
}

/**
 * Escolhe o dia a exibir na primeira carga:
 * hoje se existir, senão o próximo dia futuro, senão o último dia.
 */
export const smartDefaultDay = (allDays: ScheduleDayMap): string | null => {
  const today = DateTime.now().toISODate()
  const dayKeys = Object.keys(allDays)

  if (!dayKeys.length) return null
  if (today && dayKeys.includes(today)) return today

  const future = today ? dayKeys.find(key => key > today) : undefined
  if (future) return future

  return dayKeys[dayKeys.length - 1]
}

/** Ordem cronológica dos dias (ISO date sort). */
export const sortDayKeysChronologically = (dayKeys: string[]): string[] =>
  [...dayKeys].sort()
